<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" md="5">
        <v-card v-if="!loading && me">
          <v-card-title>
            <v-list-item>
              <v-list-item-avatar color="error" size="80">
                <span class="white--text headline">{{ me.firstName[0] }} {{ me.lastName[0] }}</span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle class="headline">{{ me.firstName }} {{ me.lastName }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card-title>
          <v-card-text>
            <v-list :flat="true">
              <v-list-item-group>
                <v-list-item>
                  <v-list-item-action>
                    <v-list-item-title class="py-2">Email: </v-list-item-title>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="py-2">{{ me.email }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-list-item-title class="py-2">Phone: </v-list-item-title>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="py-2">{{ me.phone }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-list-item-title class="py-2">Reset Password: </v-list-item-title>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="py-2">
                      <a href="/account/reset-password">Reset Password</a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
        <v-card class="mt-5 px-4 py-2">
          <v-card-title>Client-sitting Blocks</v-card-title>
          <v-card-text class="warning--text">Please don't overlap dates</v-card-text>
          <v-card-text v-if="secondaryCoachingBlocks.length == 0">
            No client-sitting Blocks
          </v-card-text>
          <v-list :flat="true">
            <v-list-item-group>
              <v-list-item v-for="block in secondaryCoachingBlocks" :key="block.id">
                <v-list-item-content>
                  <v-list-item-title class="py-2"
                    >{{ compactDate(block.startDate) }}
                    <span v-if="block.startDate != block.endDate">
                      - {{ compactDate(block.endDate) }}</span
                    ></v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-title class="py-2">
                    <v-btn small @click="viewBlock(block)">
                      View / Edit
                    </v-btn></v-list-item-title
                  >
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-card-actions>
            <v-spacer />
            <v-btn color="secondary" @click="modal.show = true">
              Setup for my leave
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-if="modal.show"
      v-model="modal.show"
      width="900"
      transition="dialog-bottom-transition"
      class="limited-height"
    >
      <client-management :existingBlock="modal.coachingPeriod" @close="closeModal()"></client-management>
    </v-dialog>
  </v-container>
</template>

<script>
import { ACCOUNT_QUERY } from "../../constants/graphql/account/account";
import ClientManagement from "../shared/ClientManagement";

export default {
  name: "Profile",
  components: {
    ClientManagement,
  },
  data() {
    return {
      loading: true,
      me: {},
      secondaryCoachingBlocks: [],
      modal: {
        show: false,
        coachingPeriod: null,
      },
    };
  },
  methods: {
    viewBlock(coachingPeriod) {
      this.modal = {
        show: true,
        coachingPeriod: coachingPeriod,
      };
    },
    closeModal() {
      this.modal = {
        show: false,
        coachingPeriod: null,
      };
      this.$apollo.queries.me.refetch();
    },
    compactDate(value) {
      return this.$moment(value)?.format("ddd, DD MMM");
    },
  },
  apollo: {
    me: {
      query: ACCOUNT_QUERY,
      variables() {
        return {
          userId: this.$store.getters.user.id,
        };
      },
      result(response) {
        if (response.data) {
          this.secondaryCoachingBlocks = response.data.secondaryCoachingPeriods;
          this.loading = false;
        }
      },
    },
  },
};
</script>

<style scoped>
.limited-height {
  height: 650px;
}
</style>
